'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _dofOverlay = require('../dof-overlay');

var _dofOverlay2 = _interopRequireDefault(_dofOverlay);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

var _dolphinNativeBridge = require('dolphin-native-bridge');

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var animation = weex.requireModule('animation');
var platform = weex.config.env.platform;

var isWeb = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && platform.toLowerCase() === 'web';
exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: { DofOverlay: _dofOverlay2.default },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    pos: {
      type: String,
      default: 'bottom'
    },
    // 背景色  暂不开放
    popupColor: {
      type: String,
      default: ''
    },
    overlayCfg: {
      type: Object,
      default: function _default() {
        return {
          hasAnimation: true,
          timingFunction: ['ease-in', 'ease-out'],
          duration: 300
        };
      }
    },
    height: {
      type: [Number, String],
      default: 840
    },
    standOut: {
      type: [Number, String],
      default: 0
    },
    width: {
      type: [Number, String],
      default: 750
    },
    animation: {
      type: Object,
      default: function _default() {
        return {
          // timingFunction: 'ease-in'
          timingFunction: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)'
        };
      }
    },
    button: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    borderRadius: {
      type: String,
      default: '32px'
    },
    isOverLayClickHide: {
      type: Boolean,
      default: false
    },
    safeAreaBgColor: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      haveOverlay: true,
      isOverShow: true,
      bottomArc: 0,
      show_: false,
      overlayShow: false,
      sageHeight: 68
    };
  },
  computed: {
    isipx: function isipx() {
      if (this.bottomArc) return true;
      if (weex && weex.config.env.platform == 'harmony' && weex.config.env.safeAreaBottomHeight) return true;
      return weex && (weex.config.env.deviceModel === 'iPhone10,3' || weex.config.env.deviceModel === 'iPhone10,6' || // iphoneX
      weex.config.env.deviceModel === 'iPhone11,8' || // iPhone XR
      weex.config.env.deviceModel === 'iPhone11,2' || // iPhone XS
      weex.config.env.deviceModel === 'iPhone11,4' || weex.config.env.deviceModel === 'iPhone11,6' || // iPhone XS Max
      weex.config.env.deviceModel === 'iPhone12,1' || // iPhone11
      weex.config.env.deviceModel === 'iPhone12,3' || weex.config.env.deviceModel === 'iPhone12,5' || // iPhone 11 Pro iPhone 11 Pro Max
      weex.config.env.deviceModel === 'iPhone13,1' || weex.config.env.deviceModel === 'iPhone13,2' || // iPhone12 Mini && iPhone12
      weex.config.env.deviceModel === 'iPhone13,3' || //iPhone12 Pro
      weex.config.env.deviceModel === 'iPhone13,4' || // iPhone12 Pro Max
      weex.config.env.deviceModel === 'iPhone14,4' || //iPhone 13 mini
      weex.config.env.deviceModel === 'iPhone14,5' || //iPhone 13
      weex.config.env.deviceModel === 'iPhone14,2' || //iPhone 13 Pro
      weex.config.env.deviceModel === 'Iphone14,3') //iPhone 13 Pro Max
      ;
    },
    _height: function _height() {
      var height = this.height,
          isipx = this.isipx,
          pos = this.pos;

      height = Number(height);
      height = isipx && pos == 'bottom' ? height + this.sageHeight : height;
      return height;
    },
    transformValue: function transformValue() {
      return this.getTransform(this.pos, this.width, this.height, true);
    },
    _popupColor: function _popupColor() {
      if (this.popupColor) return this.popupColor;
      return this._isColmo ? '#1c1e21' : this._isDiablo ? '#1e2326' : '#fff';
    },
    padStyle: function padStyle() {
      var pos = this.pos,
          width = this.width,
          height = this.height,
          _popupColor = this._popupColor,
          _height = this._height;

      var style = {
        width: width + 'px',
        backgroundColor: _popupColor
      };
      pos === 'top' && (style = _extends({}, style, {
        top: -height + 'px',
        height: height + 'px',
        borderBottomLeftRadius: this._isColmo ? 0 : this.borderRadius,
        borderBottomRightRadius: this._isColmo ? 0 : this.borderRadius
      }));
      pos === 'bottom' && (style = _extends({}, style, {
        bottom: -_height - 1 + 'px',
        height: _height + 'px',
        borderTopLeftRadius: this._isColmo ? 0 : this.borderRadius,
        borderTopRightRadius: this._isColmo ? 0 : this.borderRadius
      }));
      pos === 'left' && (style = _extends({}, style, {
        left: -width + 'px'
      }));
      pos === 'right' && (style = _extends({}, style, {
        right: -width + 'px'
      }));
      return style;
    },
    buttonComp: function buttonComp() {
      return this.button;
    }
  },
  watch: {
    _height: function _height() {
      this.appearPopup(this.show_, 0);
    },
    show_: function show_(val) {
      var _this = this;

      setTimeout(function () {
        val && _this.appearPopup(val);
      }, 100);
    },

    show: {
      handler: function handler(val, oldVal) {
        var _this2 = this;

        if (val) {
          this.overlayShow = true;
          setTimeout(function () {
            _this2.show_ = true;
          }, 0);
        } else {
          if (oldVal !== true) return;
          this.appearPopup(false, 300, function () {});
          setTimeout(function () {
            _this2.show_ = false;
            _this2.overlayShow = false;
          }, 400);
        }
      },

      immediate: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    _dolphinNativeBridge.Bridge.getAllBarHeight().then(function (res) {
      _this3.bottomArc = res.bottomArc || 0;
    });
    if (weex && weex.config.env.platform == 'harmony' && weex.config.env.safeAreaBottomHeight) {
      this.sageHeight = weex.config.env.safeAreaBottomHeight / weex.config.env.scale;
    }
  },

  methods: {
    actionsheetBtnClick: function actionsheetBtnClick(index, text) {
      this.appearPopup(false);
      this.$refs.overlay.appearOverlay(false);
      this.$emit('dofPopupButtonClicked', { index: index, text: text });
    },
    handleTouchEnd: function handleTouchEnd(e) {
      // 在支付宝上面有点击穿透问题
      var platform = weex.config.env.platform;

      platform === 'Web' && e.preventDefault && e.preventDefault();
    },
    hide: function hide() {
      this.appearPopup(false);
      this.$refs.overlay.appearOverlay(false);
    },
    dofOverlayBodyClicking: function dofOverlayBodyClicking() {
      var _this4 = this;

      this.isOverLayClickHide && this.isShow && this.appearPopup(false);
      setTimeout(function () {
        _this4.$emit('dofPopupOverlayClicked');
      }, 100);
    },
    appearPopup: function appearPopup(bool) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

      this.isShow = bool;
      var popupEl = this.$refs['dof-popup'];
      if (!popupEl) {
        return;
      }
      animation.transition(popupEl, _extends({
        styles: {
          transform: this.getTransform(this.pos, this.width, this._height, !bool) //_height解决iphonex系列向上过渡距离不够的问题
        },
        duration: duration,
        delay: 0
      }, this.animation), function () {
        cb();
        if (!bool) {
          // this.$emit('dofPopupOverlayClicked', { pos: this.pos })
        }
      });
    },
    getTransform: function getTransform(pos, width, height, bool) {
      var _size = pos === 'top' || pos === 'bottom' ? height : width;
      var _transform = void 0;
      if (isWeb) {
        _size -= this.standOut;
      }
      bool && (_size = 0);
      switch (pos) {
        case 'top':
          _transform = 'translateY(' + _size + 'px)';
          break;
        case 'bottom':
          _transform = 'translateY(-' + _size + 'px)';
          break;
        case 'left':
          _transform = 'translateX(' + _size + 'px)';
          break;
        case 'right':
          _transform = 'translateX(-' + _size + 'px)';
          break;
      }
      return _transform;
    }
  },
  genBtnText: function genBtnText(item) {
    if (_utils2.default.isPlainObject(item)) {
      return item.text;
    } else {
      return item;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-popup/index.vue
// module id = 364
// module chunks = 0 1